import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import apex from '../../apex';
import config from '../../config';
import { change, untouch } from 'redux-form';
import LogoutEventSubscriptionService from '../../services/subscriptions/LogoutEventSubscriptionService';
import { getGoogleQrCode } from './userActions';
export var AUTH_SUCCESS = 'AUTH_SUCCESS';
export var AUTH_ERROR = 'AUTH_ERROR';
export var AUTH_NONE = 'AUTH_NONE';
export var AUTH_REDIRECT = 'AUTH_REDIRECT';
export var AUTH_2FA_REQUIRED = 'AUTH_2FA_REQUIRED';
export var FORCED_LOGOUT = 'FORCED_LOGOUT';
export var ENABLE_2FA_REQUIRED = 'ENABLE_2FA_REQUIRED';
export var login = function login(creds) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var auth;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apex.connection.WebAuthenticateUser(creds);
            case 2:
              auth = _context.sent;
              if (!(auth.Authenticated && auth.Requires2FA)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt('return', dispatch(require2FA(auth)));
            case 7:
              if (!auth.Authenticated) {
                _context.next = 13;
                break;
              }
              if (!auth.EnforceEnable2FA) {
                _context.next = 10;
                break;
              }
              return _context.abrupt('return', dispatch(forceEnable2FA(creds)));
            case 10:
              return _context.abrupt('return', dispatch(authSuccess(auth)));
            case 13:
              dispatch(change('login', 'password', ''));
              dispatch(untouch('login', 'password'));
              return _context.abrupt('return', dispatch(authError(auth)));
            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var forceEnable2FA = function forceEnable2FA(creds) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(getGoogleQrCode());
              return _context2.abrupt('return', dispatch(enforceEnable2FA(creds)));
            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var enforceEnable2FA = function enforceEnable2FA(creds) {
  return {
    type: ENABLE_2FA_REQUIRED,
    payload: {
      creds: creds,
      enable2FARequired: true
    }
  };
};
export var logout = function logout() {
  return function (dispatch, getState) {
    var wasAuthenticatedBefore = getState().auth.isAuthenticated;
    var action = setUserNotAuthenticated(wasAuthenticatedBefore);
    apex.connection.RPCPromise('LogOut', {}).then(function (res) {
      console.log('logged out');
    }).catch(function (err) {
      console.warn(err);
    });
    localStorage.removeItem('tradingServer');
    dispatch(action);
  };
};
export var authSuccess = function authSuccess(payload) {
  return {
    type: AUTH_SUCCESS,
    payload: {
      isAuthenticated: payload.Authenticated,
      userId: payload.UserId,
      token: payload.SessionToken,
      pending: false,
      is2FARequired: false
    }
  };
};
export var authError = function authError(payload) {
  return {
    type: AUTH_ERROR,
    payload: {
      isAuthenticated: payload.Authenticated,
      errorMsg: payload.errormsg,
      pending: false
    }
  };
};
export var subscribeToLogoutEvent = function subscribeToLogoutEvent() {
  return function (dispatch) {
    LogoutEventSubscriptionService.subscribe(function (message) {
      dispatch(forcedLogOut(message));
    });
  };
};
var forcedLogOut = function forcedLogOut(message) {
  return {
    type: FORCED_LOGOUT,
    payload: message
  };
};
export var require2FA = function require2FA(payload) {
  return {
    type: AUTH_2FA_REQUIRED,
    payload: {
      userId: payload.UserId,
      is2FARequired: true
    }
  };
};
export var setUserNotAuthenticated = function setUserNotAuthenticated() {
  var wasAuthenticatedBefore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: AUTH_NONE,
    payload: {
      isAuthenticated: false,
      userId: null,
      token: null,
      pending: false,
      wasAuthenticatedBefore: wasAuthenticatedBefore
    }
  };
};
export var redirectFromLogin = function redirectFromLogin(location) {
  return {
    type: AUTH_REDIRECT,
    payload: {
      shouldRedirect: !!location,
      location: location
    }
  };
};
export var validateSessionToken = function validateSessionToken(token) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var authTimeout, timeoutID, auth;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              authTimeout = config.global.authTimeout;
              timeoutID = authTimeout ? setTimeout(function () {
                localStorage.removeItem('token');
                window.location.reload();
              }, authTimeout) : 0;
              _context3.next = 4;
              return apex.connection.WebAuthenticateUser({
                SessionToken: token
              });
            case 4:
              auth = _context3.sent;
              clearTimeout(timeoutID);
              if (!auth.Authenticated) {
                _context3.next = 10;
                break;
              }
              dispatch(authSuccess(auth));
              _context3.next = 12;
              break;
            case 10:
              _context3.next = 12;
              return dispatch(logout());
            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var sendTwoFactorAuthCode = function sendTwoFactorAuthCode(Code) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var auth;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return apex.connection.Authenticate2FA({
                Code: Code
              });
            case 2:
              auth = _context4.sent;
              if (!auth.Authenticated) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt('return', dispatch(authSuccess(auth)));
            case 5:
              return _context4.abrupt('return', dispatch(authError(auth)));
            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};